/**
 * cartConstants.js — Constantes et helpers purs du panier.
 *
 * §5/§9 — Un seul endroit pour les invariants cart partagés entre
 *          CartCheckoutModal, BuyFlow, useMultiVendorCapabilities.
 */

/**
 * Plafond fiat (Stripe / PayPal) — FALLBACK RÉSEAU UNIQUEMENT (P1-1, TRACK-2026-07-03).
 * La source de vérité est désormais AppSettings.fiat_cap_usd côté serveur (administrable
 * dans Settings admin, enforcée sur toutes les initiations fiat). Les consommateurs
 * (BuyFlow, CartCheckoutModal, useMultiVendorCapabilities) lisent la valeur serveur via
 * src/hooks/useFiatCap.js ; cette constante n'est utilisée que si le fetch échoue.
 */
export const FIAT_CAP_USD = 2000;

/**
 * Construit le payload items pour les endpoints cart de paiement (Stripe / PayPal / NowPayments).
 * Format attendu : { itemType, itemId, couponId, priceAtCart }.
 *
 * NE PAS utiliser pour l'endpoint /cart/validate (format différent : { itemType, itemId } seulement).
 *
 * @param {Array} cartItems — items depuis le store Redux
 * @returns {Array}
 */
export function buildCartItemsPayload(cartItems) {
  return (cartItems || []).map((i) => ({
    itemType: i.itemType,
    itemId: i.itemId,
    couponId: i.couponId || null,
    priceAtCart: i.priceUSD,
    // NFT cart §SPEC : forward saleKind (PRIMARY=mint, SECONDARY=transfer) au backend.
    // Omis pour TILE/TILEGROUP (n'utilisent pas ce champ).
    ...(i.saleKind ? { saleKind: i.saleKind } : {}),
  }));
}
